export default __webpack_public_path__ + "static/media/prepare_prescription_active.b5e3a258.svg";